import {noChange} from 'lit';
import {Directive, directive} from 'lit/directive.js';

class ImageFallback extends Directive {

	/**
	 * Stores the number of failed image calls
	 * @type {number}
	 */
	errorCounter = 0;

	constructor () {
		super();
	}

	handleImageError (element, source) {
		if (this.errorCounter <= 1) {
			element.src = source;
		}

		this.errorCounter++;
	}

	/**
	 * @param {import('lit/directive').Part} part
	 * @param {[string, ...any]}
	 */
	update (part, [source]) {
		// eslint-disable-next-line array-element-newline
		part.element.onerror = this.handleImageError.bind(this, part.element, source);

		return this.render();
	}

	render () {
		return noChange;
	}
};

/**
 * Updates image source to provided fallback source if the original source fails to load
 */
export const imageFallback = directive(ImageFallback);
